/* Change this file to get your personal Portfolio */
import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen
const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

// Summary And Greeting Section
const illustration = {
  animated: true
};

const greeting = {
  username: "Sadaqat Ali",
  title: "Hi, I'm Sadaqat Ali",
  subTitle: emoji(
    "🚀 19-Year-Old Full Stack Developer with 3 Years of Real Client Experience | I build things that actually work for US, UK & UAE clients"
  ),
  resumeLink: "", // Add your resume link later
  displayGreeting: true
};

// Social Media Links
const socialMediaLinks = {
  linkedin: "https://www.linkedin.com/in/sadaqat-ali-4b41b2324/",
  gmail: "sadaqatalii2092@gmail.com",
  display: true
};

// Skills Section
const skillsSection = {
  title: "What I Do",
  subTitle: "I DON'T JUST WRITE CODE — I SOLVE REAL PROBLEMS FOR INTERNATIONAL CLIENTS",
  skills: [
    emoji("⚡ Mobile App Development with Flutter & Firebase - Built EZCarpool, Foodpanda Clone"),
    emoji("⚡ Backend Development with Python (Flask) & Java - REST APIs, Automation Scripts"),
    emoji("⚡ E-commerce Solutions - Shopify & WordPress stores that actually sell"),
    emoji("⚡ Saved clients 10+ hours weekly with custom automation tools"),
    emoji("⚡ Video Editing & Graphic Design - Complete branding solutions")
  ],
  softwareSkills: [
{ skillName: "Flutter", fontAwesomeClassname: "fab fa-react" },
    { skillName: "Firebase", fontAwesomeClassname: "fas fa-fire" },
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" },
    { skillName: "Java", fontAwesomeClassname: "fab fa-java" },
    { skillName: "JavaScript", fontAwesomeClassname: "fab fa-js" },
    { skillName: "Shopify", fontAwesomeClassname: "fab fa-shopify" },
    { skillName: "WordPress", fontAwesomeClassname: "fab fa-wordpress" },
    { skillName: "Adobe Photoshop", fontAwesomeClassname: "fas fa-paint-brush" }
  ],
  display: true
};

// Education Section
const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "University of Sindh, Jamshoro",
      logo: '',
      subHeader: "Bachelor of Software Engineering",
      duration: "March 2026 - Present",
      desc: "Currently pursuing degree while building real-world applications for international clients."
    },
    {
      schoolName: "Govt. Boys Higher Secondary College, Jamshoro",
      logo: "",
      subHeader: "Intermediate (Pre-Engineering)",
      duration: "Aug 2022 - May 2024",
      desc: "Completed pre-engineering with focus on mathematics."
    },
    {
      schoolName: "Govt. Boys Higher Secondary School, Jamshoro",
      logo: "",
      subHeader: "Matriculation (Science)",
      duration: "May 2020 - May 2022",
      desc: "Completed science education."
    }
  ]
};

// Tech Stack Proficiency
const techStack = {
  viewSkillBars: true,
  experience: [
    { Stack: "Flutter & Firebase", progressPercentage: "95%" },
    { Stack: "Python/Flask Development", progressPercentage: "90%" },
    { Stack: "Shopify & WordPress", progressPercentage: "90%" },
    { Stack: "REST APIs & Backend", progressPercentage: "85%" }
  ],
  displayCodersrank: false
};

// Work Experience
const workExperiences = {
  display: true,
  experience: [
    {
      role: "Python Developer",
      company: "Freelance (US, UK, UAE Clients)",
      companylogo: require("./assets/images/America.png"),
      date: "2024 - Present",
      desc: "Built RESTful APIs using Flask. Automated backend tasks saving clients 10+ hours weekly.",
      descBullets: [
        "Created Firebase-based Flask API for real-time carpool app",
        "Developed login systems, admin panels, and data validation modules"
      ]
    },
    {
      role: "Flutter Developer",
      company: "Freelance (International Clients)",
      companylogo: require("./assets/images/flutter.png"),
      date: "2022 - Present",
      desc: "End-to-end mobile app development from UI to deployment.",
      descBullets: [
        "EZCarpool App — Ride-sharing with Firebase",
        "Admin Dashboard for transport clients",
        "Foodpanda Clone with impressive UI"
      ]
    },
    {
      role: "Shopify & WordPress Developer",
      company: "Freelance (Global Clients)",
companylogo: require("./assets/images/shopify.png"),
      date: "2021 - Present",
      desc: "Built e-commerce stores and business websites.",
      descBullets: [
        "Custom Shopify theme development",
        "WordPress + WooCommerce setups",
        "EzCarpool Website, NJ Jewellery Website"
      ]
    }
  ]
};

// Open Source
const openSource = {
  showGithubProfile: "true",
  display: true
};

// Featured Projects
const bigProjects = {
  title: "Featured Projects",
  subtitle: "REAL APPLICATIONS I'VE BUILT FOR REAL CLIENTS",
  projects: [
    {
      image: "",
      projectName: "EZCarpool",
      projectDesc: "Complete ride-sharing platform with Flutter mobile app and Firebase backend.",
      footerLink: []
    },
    {
      image: "",
      projectName: "Transport Admin Dashboard",
      projectDesc: "Mobile panel for managing users, rides, and trips.",
      footerLink: []
    },
    {
      image: "",
      projectName: "Food Delivery App",
      projectDesc: "Foodpanda clone with impressive UI and session management.",
      footerLink: []
    }
  ],
  display: true
};

// Achievement Section
const achievementSection = {
  title: emoji("Achievements 🏆"),
  subtitle: "Real results I've delivered for international clients",
  achievementsCards: [
    {
      title: "Saved Clients 10+ Hours Weekly",
      subtitle: "Built custom automation scripts that eliminated manual work for US and UK clients.",
      image: require("./assets/images/banner_1.jpeg"),
      imageAlt: "Automation Achievement",
      footerLink: []
    },
    {
      title: "US, UK & UAE Clients",
      subtitle: "Successfully delivered projects for clients across three continents. All remote, all on time.",
      image: require("./assets/images/banner_2.jpeg"),
      imageAlt: "Global Clients",
      footerLink: []
    }
  ],
  display: true
};


// Contact Info
const contactInfo = {
  title: emoji("Let's Work Together ☎️"),
  subtitle: "Have a project in mind? My inbox is open for serious opportunities.",
  number: "+92-320396980",
  email_address: "sadaqatalii2092@gmail.com"
};

// Required sections that components expect (set to false to hide)
const blogSection = { display: false, blogs: [] };
const talkSection = { display: false, talks: [] };
const podcastSection = { display: false, podcast: [] };
const twitterDetails = { display: false };
const resumeSection = { display: true };
const isHireable = true;

// Export all sections
export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};